import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-32 bg-background" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">FAQ</p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-primary">
            Frequently asked questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-border bg-card px-5 data-[state=open]:border-primary/40 data-[state=open]:shadow-sm transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-heading text-lg text-primary hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
